export default __webpack_public_path__ + "static/indoor20-acd7a01e8ab6f40d88a318b3aaf711c9.webp";